import { Navigate, useParams } from "react-router-dom";

import { useStatefulRun } from "../api/hooks/useStatefulAgents";
import { statefulRunPage } from "./learningAgentPaths";

// Where a link to a run known only by its id lands: which page shows a run depends on its
// kind and project, so it is looked up here and opened there.
export const StatefulRunRedirectRoute = () => {
  const { runId } = useParams<{ runId: string }>();
  const decoded = runId ? decodeURIComponent(runId) : "";
  const run = useStatefulRun(decoded || null);
  if (run.data) {
    return <Navigate to={statefulRunPage(run.data.run)} replace />;
  }
  if (run.isError || !decoded) {
    const detail = run.error instanceof Error ? run.error.message : "no run id";
    return (
      <p>
        Could not open run <code>{decoded}</code>: {detail}
      </p>
    );
  }
  return <p>Opening run…</p>;
};
